// 处理会话未读数量（只处理了处理中的会话）
import store from '@/store'
import { queryAllGroupId } from '@/api/chat'
import useTopUp from '@/hooks/useTopUp'
const { recoverAllTopList } = useTopUp()
// 获取当前群聊ID
const getGroupId = async () => {
  const data = await queryAllGroupId()
  return data || []
}
// 初始化需要从缓存获取群信息
// 判断群组有没有缓存信息，如果有就把缓存里的信息同步到store.chat.msgList
// 主要用于刷新
export const setMsgListFromStorage = async () => {
  const groupObj = JSON.parse(localStorage.getItem('storeChatMsgList'))
  if (groupObj && groupObj.group) {
    const groupList = await getGroupId()
    if (groupList.length > 0) {
      // 先判断当前缓存里的群组id的群还存不存在如果不存在就清除
      Object.keys(groupObj.group).map(item => {
        if (!groupList.includes(item)) {
          delete groupObj.group[item]
        }
      })
      localStorage.setItem('storeChatMsgList', JSON.stringify(groupObj))
      store.commit('setMsgList', groupObj)
      setUnreadCount(groupObj)
    } else {
      clearStoreChatMsgList(groupList)
    }
  }
}
// 设置未读数并更新store中未读数量
export const setUnreadCount = data => {
  const count = unreadCount(data.group)
  store.dispatch('workOrder/setUnReadNum', {
    processingUnNum: count
  })
}

/**
 * @description: 处理中工单未读数量（处理中工单都建立im聊天）
 * @param {Array} orders 当前所有工单
 */
export function unreadCount(group) {
  let count = 0
  for (const item in group) {
    if (group[item].length > 0) {
      // group[item].forEach(el => {
      //   el.status === 'unread' && el.customEvent !== '23009' && count++ // 23009-单病种随访问卷 免打扰
      // })
      const arr = group[item]
      // 工单免打扰
      // 50800- ai
      // 23009 - 单病种随访问卷
      const notTips = ['23009', '50800']
      const lent = arr
        .filter(el => !notTips.includes(el.customEvent))
        .filter(el => el.status === 'unread').length
      count += lent
    }
  }
  return count
}

// 设置当前群组信息缓存并更新会话列表
// 主要是存最新消息到缓存并更新会话列表
export const setStoreChatMsgList = (msgList, type = '') => {
  if (Object.keys(msgList.group).length <= 0) {
    if (type !== 'noUpDate') {
      clearStoreChatMsgList()
    }
  } else {
    const groupObj = {
      group: msgList.group
    }
    localStorage.setItem('storeChatMsgList', JSON.stringify(groupObj))
    if (type !== 'noUpDate') {
      store.commit('setMsgList', msgList)
    }
    setUnreadCount(msgList)
  }
}

// 清除当前群组缓存
export const clearStoreChatMsgList = async dataList => {
  const groupList = dataList || (await getGroupId())

  if (groupList.length <= 0) {
    localStorage.removeItem('storeChatMsgList')
    store.dispatch('workOrder/setUnReadNum', {
      processingUnNum: 0
    })
    store.commit('setMsgList', { group: {} })
    //将置顶工单回收
    recoverAllTopList()
  }
}

// 设置某个会话的未读状态再更新store
export const setStoreChatMsgListReadGroupId = (name, groupId, type) => {
  const groupObj = JSON.parse(localStorage.getItem('storeChatMsgList'))
  new Promise((resolve, reject) => {
    if (groupObj && groupObj[name][groupId]) {
      groupObj[name][groupId].map(item => {
        item.status === 'read'
        if (type === 'del') {
          delete groupObj[name][groupId]
        }
      })
    }
    resolve(groupObj)
  }).then(res => {
    localStorage.setItem('storeChatMsgList', JSON.stringify(res))
    setMsgListFromStorage()
  })
}
